"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M8.7 7.003C8.7 5.9 9.594 5 10.7 5h2.6c1.106 0 2 .899 2 2.003V9.61q0 .043-.002.085c-.002 2.24-.11 4.518-.865 6.25-.392.898-.968 1.677-1.813 2.226-.843.548-1.897.829-3.183.829a.7.7 0 1 1 0-1.4c1.08 0 1.853-.235 2.42-.603s.985-.906 1.293-1.611c.449-1.029.637-2.35.71-3.851q-.268.078-.56.079h-2.6c-1.106 0-2-.899-2-2.004z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=ThousandsIcon24.js.map